/**
 * Returns the exact substring from `text` that matches `searchTerm` (case-insensitive).
 * Typography's highlight prop requires the exact string present in children for split() to work.
 */
const getMatchingHighlightSubstring = (
  text: string | null | undefined,
  searchTerm: string | null | undefined,
): string | undefined => {
  const trimmedSearch = searchTerm?.trim();

  if (!text || !trimmedSearch) return undefined;

  const matchIndex = text.toLowerCase().indexOf(trimmedSearch.toLowerCase());

  if (matchIndex === -1) return undefined;

  return text.slice(matchIndex, matchIndex + trimmedSearch.length);
};

export default getMatchingHighlightSubstring;
